/**
 * JU!CE — PDP · compra.
 *
 * Seis web components, todos progressive enhancement (a página funciona sem JS):
 *   <jp-buy-form>   — intercepta o submit do {% form 'product' %}. A quantidade vem
 *                     do <select name="quantity"> do pack (o <jp-select> só o veste),
 *                     e trocar de pack reescreve a linha de preço a partir dos
 *                     data-jp-total / data-jp-was / data-jp-dose já formatados pelo
 *                     Liquid. O Kit Sachês só entra no carrinho quando o Liquid
 *                     renderiza [data-jp-upsell] — isto é, quando o lojista liga
 *                     "Adicionar o kit ao carrinho". Com o brinde automático da
 *                     Yampi (carrinho ≥ R$ 398) esse input NÃO existe e o tema manda
 *                     apenas o pote × quantidade.
 *   <jp-select>     — dropdown custom (sabor e pack) com listbox acessível. Modo
 *                     "navigate" (sabor) navega para a PDP do outro sabor; modo
 *                     "native" (pack) escreve num <select> real, que continua sendo
 *                     o controle do formulário. Enquanto o componente não assume, o
 *                     fallback sem JS (lista de links / select nativo) fica visível.
 *   <jp-tip>        — popover do "?" do brinde.
 *   <jp-offer-timer>— contador da OFERTA DO MÊS. Conta até o fim em Brasília (-03:00
 *                     fixo) e, ao zerar com a página aberta, derruba o bloco para o
 *                     modo pago invertendo `hidden` de markup que o Liquid já entregou.
 *                     Sem JS a linha do contador fica em branco (espaço reservado por
 *                     CSS, sem CLS) — a oferta em si continua funcionando.
 *   <jp-gallery>    — thumbs trocam o slide do rail (que sem JS já funciona por
 *                     âncora + scroll-snap) e o botão de zoom abre um lightbox.
 *   <jp-sticky-cta> — barra fixa mobile: aparece quando o CTA principal sai da
 *                     viewport por cima e some com o cart drawer aberto.
 *
 * Carrinho: usa window.themeCore.CartApi (Victory) quando existe —
 * ADD_TO_CART_MANY quando há upsell, ADD_TO_CART quando não há — e depois GET_CART,
 * que é o que o Victory escuta para atualizar o contador do header e abrir a
 * notificação de carrinho. Sem themeCore, cai em fetch direto para /cart/add.js
 * (que aceita `items`, então um único POST resolve os dois itens).
 */
(function () {
  'use strict';

  var DONE_MS = 1800;
  var DRAWER_SELECTOR = '#CartDrawer, .cart-drawer, .drawer';
  var DRAWER_OPEN_CLASS = 'is-active';

  /* Brasília = UTC-03:00 FIXO. O Brasil extinguiu o horário de verão em 2019, então
     não existe janela do ano em que este offset mude. Todo cálculo de "fim da oferta"
     passa por aqui em vez de confiar no fuso do navegador ou no fuso da loja. */
  var BR_OFFSET_MIN = -180;

  function two(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  /* Converte um epoch (ms) para os campos de PAREDE de Brasília. Truque: desloca o
     epoch pelo offset e lê os campos em UTC — assim getUTC* devolve a hora local -03. */
  function brFields(ms) {
    var d = new Date(ms + BR_OFFSET_MIN * 60000);
    return {
      ano: d.getUTCFullYear(),
      mes: d.getUTCMonth(), // 0-11
      dia: d.getUTCDate(),
      hora: d.getUTCHours(),
      min: d.getUTCMinutes()
    };
  }

  /* Último instante do mês corrente (23:59:59 de Brasília), devolvido em epoch ms.
     Date.UTC(ano, mes + 1, 1) = 00:00 do dia 1 do mês seguinte; menos 1s = 23:59:59 do
     último dia (28/29/30/31 resolvidos pelo próprio calendário). Esse valor é uma hora
     de PAREDE, então volta para epoch real descontando o offset. */
  function fimDoMesBrasilia(agoraMs) {
    var f = brFields(agoraMs);
    var parede = Date.UTC(f.ano, f.mes + 1, 1, 0, 0, 0) - 1000;
    return parede - BR_OFFSET_MIN * 60000;
  }

  function dataCurtaBr(ms) {
    var f = brFields(ms);
    return two(f.dia) + '/' + two(f.mes + 1);
  }

  function dataLegivelBr(ms) {
    var f = brFields(ms);
    return (
      two(f.dia) + '/' + two(f.mes + 1) + '/' + f.ano + ' às ' + two(f.hora) + ':' + two(f.min)
    );
  }

  function getCartApi() {
    var core = window.themeCore;
    if (core && core.CartApi && typeof core.CartApi.makeRequest === 'function') {
      return core.CartApi;
    }
    return null;
  }

  function addItems(items) {
    var cartApi = getCartApi();

    if (cartApi) {
      var action =
        items.length > 1 && cartApi.actions.ADD_TO_CART_MANY
          ? cartApi.actions.ADD_TO_CART_MANY
          : null;

      var request = action
        ? cartApi.makeRequest(action, items)
        : sequential(cartApi, items);

      return request.then(function (result) {
        cartApi.makeRequest(cartApi.actions.GET_CART).catch(function () {});
        return result;
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error((err && err.description) || 'cart_add_failed');
          });
        }
        return response.json();
      })
      .then(function (data) {
        updateCartCountFallback();
        return data;
      });
  }

  /* Sem ADD_TO_CART_MANY (tema antigo): duas chamadas, em ordem. */
  function sequential(cartApi, items) {
    return items.reduce(function (chain, item) {
      return chain.then(function () {
        return cartApi.makeRequest(cartApi.actions.ADD_TO_CART, item);
      });
    }, Promise.resolve());
  }

  function updateCartCountFallback() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll(
          '.js-header-cart-item-count-wrapper, .js-cart-count, [data-cart-count]'
        );
        nodes.forEach(function (el) {
          el.setAttribute('data-cart-count', cart.item_count);
          if (!el.querySelector('*')) {
            el.textContent = cart.item_count;
          }
        });
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------ <jp-buy-form> */
  function defineBuyForm() {
    if (customElements.get('jp-buy-form')) return;

    class JpBuyFormElement extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-jp-cta]');
        this.label = this.querySelector('[data-jp-cta-label]');
        this.priceNode = this.querySelector('[data-jp-price]');
        this.statusNode = this.querySelector('[data-jp-status]');
        this.upsell = this.querySelector('[data-jp-upsell]');
        this.upsellNote = this.querySelector('[data-jp-upsell-note]');
        this.variantSelect = this.querySelector('[data-jp-variant]');
        this.wasNode = this.querySelector('[data-jp-was]');
        this.doseNode = this.querySelector('[data-jp-dose]');
        this.packSelect = this.querySelector('select[name="quantity"]');
        this.quantities = Array.prototype.slice.call(this.querySelectorAll('[data-jp-qty]'));
        /* Página de oferta: setting "Ir direto pro checkout ao comprar" (default ligado).
           Depois do add, chama window.yampiClick() (snippets/YampiSnippet.liquid) em vez
           de deixar o drawer nativo do Victory abrir — só quando a função existe. */
        this._checkoutDireto = this.getAttribute('data-jp-checkout-direto') === 'true';
        if (!this.form) return;

        this._defaultLabel = this.label ? this.label.textContent : '';
        this._onSubmit = this.onSubmit.bind(this);
        this._onQuantity = this.onQuantity.bind(this);
        this._onVariant = this.onVariant.bind(this);
        this._onUpsell = this.onUpsell.bind(this);
        this._onOfferExpired = this.onOfferExpired.bind(this);
        this._onPack = this.onPack.bind(this);

        this.form.addEventListener('submit', this._onSubmit);
        if (this.packSelect) {
          this.packSelect.addEventListener('change', this._onPack);
        }
        this.addEventListener('jp:offer-expired', this._onOfferExpired);
        this.quantities.forEach(function (input) {
          input.addEventListener('change', this._onQuantity);
        }, this);
        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', this._onVariant);
        }
        if (this.upsell) {
          this.upsell.addEventListener('change', this._onUpsell);
          this.onUpsell();
        }
      }

      disconnectedCallback() {
        if (this.form && this._onSubmit) {
          this.form.removeEventListener('submit', this._onSubmit);
        }
        this.quantities.forEach(function (input) {
          input.removeEventListener('change', this._onQuantity);
        }, this);
        if (this.variantSelect && this._onVariant) {
          this.variantSelect.removeEventListener('change', this._onVariant);
        }
        if (this.upsell && this._onUpsell) {
          this.upsell.removeEventListener('change', this._onUpsell);
        }
        if (this.packSelect && this._onPack) {
          this.packSelect.removeEventListener('change', this._onPack);
        }
        if (this._onOfferExpired) {
          this.removeEventListener('jp:offer-expired', this._onOfferExpired);
        }
      }

      /* O <jp-offer-timer> zerou com a página aberta. O visual do bloco quem troca é
         ele; aqui fica a parte de FORMULÁRIO: caixa desmarcada (o kit não vai mais de
         graça) e a linha "+ Kit Sachês incluso" fora do DOM lógico — a referência é
         zerada para o onUpsell não ressuscitá-la se o cliente remarcar a caixa. */
      onOfferExpired() {
        if (this.upsell) this.upsell.checked = false;
        if (this.upsellNote) {
          this.upsellNote.hidden = true;
          this.upsellNote = null;
        }
      }

      /* Linha "+ Kit Sachês incluso" abaixo do preço: só espelha o checkbox da
         oferta. O preço grande NÃO muda — o kit é brinde (desconto automático no
         Admin) e, no modo pago, o valor dele aparece no carrinho. */
      onUpsell() {
        if (!this.upsellNote || !this.upsell) return;
        this.upsellNote.hidden = !this.upsell.checked;
      }

      /* Pack (1/2/3 potes do MESMO produto). Todos os números já vêm formatados pelo
         Liquid com o filtro `money` da loja — o JS só troca texto, nunca calcula
         preço nem inventa desconto. */
      onPack() {
        if (!this.packSelect) return;
        var option = this.packSelect.options[this.packSelect.selectedIndex];
        if (!option) return;

        var total = option.getAttribute('data-jp-total');
        var was = option.getAttribute('data-jp-was');
        var dose = option.getAttribute('data-jp-dose');

        if (total && this.priceNode) this.priceNode.textContent = total;
        if (was && this.wasNode) this.wasNode.textContent = was;
        if (dose && this.doseNode) this.doseNode.textContent = dose;

        var sticky = document.querySelector('[data-jp-sticky-price]');
        if (sticky && total) sticky.textContent = total;
      }

      /* Sobrou do seletor de 1/2/3 potes: se algum dia um bloco Quantidade voltar,
         o preço grande segue o data-jp-total pré-formatado no Liquid. Em produto
         multivariante o Liquid não emite data-jp-total — o preço segue o <select>. */
      onQuantity(event) {
        if (!this.priceNode) return;
        var total = event.target.getAttribute('data-jp-total');
        if (total) this.priceNode.textContent = total;
      }

      onVariant(event) {
        var option = event.target.options[event.target.selectedIndex];
        var price = option && option.getAttribute('data-jp-price');
        if (!price) return;
        if (this.priceNode) this.priceNode.textContent = price;
        /* a barra fixa mostra o mesmo preço do módulo */
        var sticky = document.querySelector('[data-jp-sticky-price]');
        if (sticky) sticky.textContent = price;
      }

      collectItems() {
        var data = new FormData(this.form);
        var id = data.get('id');
        if (!id) return null;

        var quantity = parseInt(data.get('quantity'), 10);
        if (!quantity || quantity < 1) quantity = 1;

        var items = [{ id: id, quantity: quantity }];

        if (this.upsell && this.upsell.checked) {
          var upsellId = this.upsell.getAttribute('data-jp-upsell-id');
          if (upsellId) items.push({ id: upsellId, quantity: 1 });
        }

        return items;
      }

      onSubmit(event) {
        var items = this.collectItems();
        if (!items) return;

        event.preventDefault();
        if (this.button && this.button.hasAttribute('data-jp-busy')) return;

        var self = this;
        this.setState('loading', 'Adicionando…');

        addItems(items)
          .then(function () {
            self.setState('done', 'Adicionado ✓');
            self.dispatchEvent(
              new CustomEvent('jp:cart-added', { bubbles: true, detail: { items: items } })
            );

            if (self._checkoutDireto && typeof window.yampiClick === 'function') {
              /* 250ms só pra "Adicionado ✓" ser percebido antes de navegar (mesmo
                 tempo usado em jp-sabores.js) — sem isso o carrinho pisca "do nada". */
              window.setTimeout(function () { window.yampiClick(); }, 250);
              return;
            }

            /* 17/09: com o checkout direto DESLIGADO (PDP normal) a compra passa pelo carrinho,
               onde moram o aviso de frete grátis, o cupom e o resumo — igual ao "Comprar agora"
               dos cards da home. Checkout direto continua valendo na sales page (?view=oferta). */
            if (!self._checkoutDireto) {
              var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              window.setTimeout(function () { window.location.href = raiz + 'cart'; }, 250);
              return;
            }

            window.setTimeout(function () { self.resetState(); }, DONE_MS);
          })
          .catch(function () {
            self.setState('error', 'Tente de novo');
            window.setTimeout(function () { self.resetState(); }, DONE_MS);
          });
      }

      setState(state, text) {
        if (this.statusNode && text) this.statusNode.textContent = text;
        this.dispatchEvent(
          new CustomEvent('jp:buy-state', { bubbles: true, detail: { state: state, text: text } })
        );
        if (!this.button) return;
        this.button.setAttribute('data-state', state);
        this.button.setAttribute('data-jp-busy', 'true');
        this.button.disabled = state === 'loading';
        if (this.label && text) this.label.textContent = text;
      }

      resetState() {
        this.dispatchEvent(
          new CustomEvent('jp:buy-state', { bubbles: true, detail: { state: null } })
        );
        if (!this.button) return;
        this.button.removeAttribute('data-state');
        this.button.removeAttribute('data-jp-busy');
        this.button.disabled = false;
        if (this.label) this.label.textContent = this._defaultLabel;
      }
    }

    customElements.define('jp-buy-form', JpBuyFormElement);
  }

  /* --------------------------------------------------------- <jp-offer-timer> */
  /**
   * Contador da OFERTA DO MÊS. Só é renderizado pelo Liquid quando a oferta está
   * ativa (e não expirada no servidor), então aqui não existe caso "oferta desligada".
   *
   * Fim da oferta:
   *   - data-jp-offer-end preenchido  -> ISO já ancorado em -03:00 pelo Liquid.
   *   - data-jp-offer-end vazio       -> último dia do mês corrente, 23:59:59 -03:00,
   *     calculado a partir do relógio do visitante. É de propósito: a PDP passa por
   *     cache de CDN, e um fim de mês pré-calculado no servidor pode chegar velho na
   *     virada; além disso `'now'` no Liquid usa o fuso da LOJA.
   *
   * Ao zerar com a página aberta, o componente NÃO inventa markup: troca a classe do
   * rótulo da oferta e inverte os `hidden` dos pedaços que o Liquid já entregou
   * (data-jp-offer-only x data-jp-offer-expired), e avisa o <jp-buy-form> por evento
   * para desmarcar a caixa e esconder o "+ Kit Sachês incluso".
   */
  function defineOfferTimer() {
    if (customElements.get('jp-offer-timer')) return;

    class JpOfferTimerElement extends HTMLElement {
      connectedCallback() {
        this.longNode = this.querySelector('[data-jp-timer-long]');
        this.shortNode = this.querySelector('[data-jp-timer-short]');
        this.srNode = this.querySelector('[data-jp-timer-sr]');
        this.dateNode = this.querySelector('[data-jp-timer-date]');

        this.endMs = this.resolveEnd();

        /* Linha visível "Oferta válida até DD/MM". No modo automático (fim do mês) o
           Liquid deixa o span vazio de propósito — quem sabe a data é este componente. */
        if (this.dateNode) {
          this.dateNode.textContent = dataCurtaBr(this.endMs);
        }

        /* Frase estática do leitor de tela: escrita UMA vez, com o fim resolvido aqui
           (o Liquid só preenche o fallback sem-JS, e no modo automático nem isso). */
        if (this.srNode) {
          this.srNode.textContent =
            'Oferta válida até ' + dataLegivelBr(this.endMs) + ' (horário de Brasília).';
        }

        this.tick();
        if (!this._expired) {
          this._timer = window.setInterval(this.tick.bind(this), 1000);
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (this._timer) {
          window.clearInterval(this._timer);
          this._timer = null;
        }
      }

      resolveEnd() {
        var raw = (this.getAttribute('data-jp-offer-end') || '').trim();
        if (raw) {
          var parsed = Date.parse(raw);
          if (!isNaN(parsed)) return parsed;
        }
        return fimDoMesBrasilia(Date.now());
      }

      tick() {
        var restante = Math.floor((this.endMs - Date.now()) / 1000);

        if (restante <= 0) {
          this.expire();
          return;
        }

        var d = Math.floor(restante / 86400);
        var h = Math.floor((restante % 86400) / 3600);
        var m = Math.floor((restante % 3600) / 60);
        var s = restante % 60;

        if (this.longNode) {
          this.longNode.textContent = d + 'd ' + two(h) + 'h ' + two(m) + 'm ' + two(s) + 's';
        }
        if (this.shortNode) {
          this.shortNode.textContent = d + 'd ' + two(h) + ':' + two(m) + ':' + two(s);
        }

        this.classList.add('is-ready');
      }

      /* Virada da oferta com a página aberta = o mesmo estado que "Oferta do mês ativa"
         desligada no editor: sem selo, sem GRÁTIS, preço do kit visível, caixa vazia. */
      expire() {
        if (this._expired) return;
        this._expired = true;
        this.stop();
        this.hidden = true;

        /* A virada apaga TODA a oferta na dobra, não só o bloco do brinde: o selo da
           galeria, o preço riscado e o item "Kit grátis" do checklist também levam
           data-jp-offer-only, e eles vivem fora de [data-jp-offer]. Por isso o escopo
           é a seção inteira. */
        var root = this.closest('.jp-pdp-purchase') || document;

        var offer = this.closest('[data-jp-offer]');
        if (offer) offer.classList.add('is-expired');

        root.querySelectorAll('[data-jp-offer-only]').forEach(function (el) {
          el.hidden = true;
        });
        root.querySelectorAll('[data-jp-offer-expired]').forEach(function (el) {
          el.hidden = false;
        });

        this.dispatchEvent(new CustomEvent('jp:offer-expired', { bubbles: true }));
      }
    }

    customElements.define('jp-offer-timer', JpOfferTimerElement);
  }

  /* ------------------------------------------------------------- <jp-gallery> */
  function defineGallery() {
    if (customElements.get('jp-gallery')) return;

    class JpGalleryElement extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-jp-rail]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-jp-slide]'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-jp-thumb]'));
        this.zoomBtn = this.querySelector('[data-jp-zoom]');
        if (!this.rail) return;

        this._onThumb = this.onThumb.bind(this);
        this._onScroll = this.onScroll.bind(this);
        this._onZoom = this.openZoom.bind(this);

        this.thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', this._onThumb);
        }, this);
        this.rail.addEventListener('scroll', this._onScroll, { passive: true });
        if (this.zoomBtn) this.zoomBtn.addEventListener('click', this._onZoom);
      }

      disconnectedCallback() {
        this.thumbs.forEach(function (thumb) {
          thumb.removeEventListener('click', this._onThumb);
        }, this);
        if (this.rail) this.rail.removeEventListener('scroll', this._onScroll);
        if (this.zoomBtn) this.zoomBtn.removeEventListener('click', this._onZoom);
        this.closeZoom();
      }

      onThumb(event) {
        var index = event.currentTarget.getAttribute('data-jp-thumb');
        var slide = this.querySelector('[data-jp-slide="' + index + '"]');
        if (!slide) return;
        event.preventDefault();
        this.rail.scrollTo({
          left: slide.offsetLeft - this.rail.offsetLeft,
          behavior: 'smooth'
        });
        this.setCurrent(index);
      }

      onScroll() {
        if (!this.slides.length) return;
        var railRect = this.rail.getBoundingClientRect();
        var center = railRect.left + railRect.width / 2;
        var closest = this.slides[0];
        var closestDistance = Infinity;

        this.slides.forEach(function (slide) {
          var rect = slide.getBoundingClientRect();
          var distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = slide;
          }
        });

        this.setCurrent(closest.getAttribute('data-jp-slide'));
      }

      setCurrent(index) {
        this._current = index;
        this.thumbs.forEach(function (thumb) {
          if (thumb.getAttribute('data-jp-thumb') === index) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      activeSlide() {
        var index = this._current;
        return (index && this.querySelector('[data-jp-slide="' + index + '"]')) || this.slides[0];
      }

      openZoom() {
        var slide = this.activeSlide();
        if (!slide) return;

        var src = slide.getAttribute('data-jp-zoom-src');
        var img = slide.querySelector('img');
        if (!src && img) src = img.currentSrc || img.src;
        if (!src) return;

        this.closeZoom();
        this._lastFocus = document.activeElement;

        var box = document.createElement('div');
        box.className = 'jp-pdp-purchase__lightbox';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-label', this.zoomBtn ? this.zoomBtn.getAttribute('aria-label') : 'Imagem ampliada');

        var picture = document.createElement('img');
        picture.className = 'jp-pdp-purchase__lightbox-img';
        picture.src = src;
        picture.alt = img ? img.alt : '';

        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'jp-pdp-purchase__lightbox-close';
        close.setAttribute('aria-label', 'Fechar');
        close.textContent = '×';

        box.appendChild(picture);
        box.appendChild(close);
        document.body.appendChild(box);

        var self = this;
        this._onKey = function (event) {
          if (event.key === 'Escape') self.closeZoom();
        };
        box.addEventListener('click', function (event) {
          if (event.target === box || event.target === close) self.closeZoom();
        });
        document.addEventListener('keydown', this._onKey);

        this._lightbox = box;
        close.focus();
      }

      closeZoom() {
        if (this._onKey) {
          document.removeEventListener('keydown', this._onKey);
          this._onKey = null;
        }
        if (this._lightbox) {
          this._lightbox.remove();
          this._lightbox = null;
        }
        if (this._lastFocus && typeof this._lastFocus.focus === 'function') {
          this._lastFocus.focus();
          this._lastFocus = null;
        }
      }
    }

    customElements.define('jp-gallery', JpGalleryElement);
  }

  /* ---------------------------------------------------------- <jp-sticky-cta> */
  function defineStickyCta() {
    if (customElements.get('jp-sticky-cta')) return;

    class JpStickyCtaElement extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-jp-sticky-submit]');
        this._defaultLabel = this.button ? this.button.textContent : '';
        this._passed = false;
        this._drawerOpen = false;

        this.watchTarget();
        this.watchDrawer();
        this.watchState();
      }

      disconnectedCallback() {
        if (this._observer) this._observer.disconnect();
        if (this._drawerObserver) this._drawerObserver.disconnect();
        if (this._onBuyState) {
          document.removeEventListener('jp:buy-state', this._onBuyState);
        }
      }

      /* Visível só depois que o CTA principal sai da viewport por cima. */
      watchTarget() {
        var id = this.getAttribute('data-jp-sticky-target');
        var target = id && document.getElementById(id);
        if (!target || typeof IntersectionObserver !== 'function') return;

        var self = this;
        this._observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              self._passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              self.render();
            });
          },
          { threshold: 0 }
        );
        this._observer.observe(target);
      }

      /* Cart drawer do Victory: <section id="CartDrawer"> ganha .is-active. */
      watchDrawer() {
        var drawers = Array.prototype.slice.call(document.querySelectorAll(DRAWER_SELECTOR));
        if (!drawers.length || typeof MutationObserver !== 'function') return;

        var self = this;
        this._drawerObserver = new MutationObserver(function () {
          self._drawerOpen = drawers.some(function (drawer) {
            return drawer.classList.contains(DRAWER_OPEN_CLASS);
          });
          self.render();
        });

        drawers.forEach(function (drawer) {
          self._drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        });
      }

      /* Espelha o estado do CTA principal (loading / adicionado / erro). */
      watchState() {
        var self = this;
        this._onBuyState = function (event) {
          if (!self.button) return;
          var state = event.detail && event.detail.state;
          if (state) {
            self.button.setAttribute('data-state', state);
            self.button.disabled = state === 'loading';
            if (event.detail.text) self.button.textContent = event.detail.text;
          } else {
            self.button.removeAttribute('data-state');
            self.button.disabled = false;
            self.button.textContent = self._defaultLabel;
          }
        };
        document.addEventListener('jp:buy-state', this._onBuyState);
      }

      render() {
        this.classList.toggle('is-visible', this._passed && !this._drawerOpen);
      }
    }

    customElements.define('jp-sticky-cta', JpStickyCtaElement);
  }

  /* -------------------------------------------------------------- <jp-select> */
  /**
   * Dropdown custom com semântica de listbox (button aria-haspopup + role="listbox"
   * / role="option"), teclado completo (setas, Home/End, Enter/Espaço, Esc) e
   * fechamento ao clicar fora.
   *
   * Dois modos:
   *   data-jp-mode="navigate" (sabor) — cada sabor é um PRODUTO, então escolher
   *     navega para data-jp-href (a PDP do outro sabor, já com ?view=oferta).
   *   data-jp-mode="native" (pack) — escreve o valor no <select name="quantity">,
   *     que continua sendo o controle real do formulário, e dispara `change` para o
   *     <jp-buy-form> atualizar a linha de preço.
   *
   * Sem JS nada disto existe: o Liquid entrega o <select> nativo (pack) e a lista de
   * links (sabor), e só aqui eles são escondidos (classe is-enhanced no host).
   */
  function defineSelect() {
    if (customElements.get('jp-select')) return;

    class JpSelectElement extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('[data-jp-select-btn]');
        this.list = this.querySelector('[data-jp-select-list]');
        this.valueNode = this.querySelector('[data-jp-select-value]');
        this.native = this.querySelector('[data-jp-select-native]');
        this.options = Array.prototype.slice.call(this.querySelectorAll('[data-jp-option]'));
        if (!this.btn || !this.list || !this.options.length) return;

        this.mode = this.getAttribute('data-jp-mode') === 'navigate' ? 'navigate' : 'native';

        /* Só agora o fallback sem JS sai de cena. */
        this.classList.add('is-enhanced');
        this.btn.hidden = false;

        this._onBtn = this.toggle.bind(this);
        this._onDocClick = this.onDocClick.bind(this);
        this._onKeydown = this.onKeydown.bind(this);
        this._onOption = this.onOption.bind(this);

        this.btn.addEventListener('click', this._onBtn);
        this.addEventListener('keydown', this._onKeydown);
        this.options.forEach(function (option) {
          option.addEventListener('click', this._onOption);
        }, this);
        document.addEventListener('click', this._onDocClick);
      }

      disconnectedCallback() {
        if (this.btn && this._onBtn) this.btn.removeEventListener('click', this._onBtn);
        if (this._onKeydown) this.removeEventListener('keydown', this._onKeydown);
        if (this._onOption) {
          this.options.forEach(function (option) {
            option.removeEventListener('click', this._onOption);
          }, this);
        }
        if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
      }

      get isOpen() {
        return this.btn.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.btn.setAttribute('aria-expanded', 'true');
        this.list.hidden = false;
        var active = this.options.filter(function (option) {
          return option.getAttribute('aria-selected') === 'true';
        })[0] || this.enabledOptions()[0];
        if (active) active.focus();
      }

      close(focusBtn) {
        this.btn.setAttribute('aria-expanded', 'false');
        this.list.hidden = true;
        if (focusBtn) this.btn.focus();
      }

      toggle() {
        if (this.isOpen) this.close(true);
        else this.open();
      }

      enabledOptions() {
        return this.options.filter(function (option) {
          return option.getAttribute('aria-disabled') !== 'true';
        });
      }

      onDocClick(event) {
        if (!this.isOpen) return;
        if (this.contains(event.target)) return;
        this.close(false);
      }

      onKeydown(event) {
        var key = event.key;

        if (key === 'Escape' && this.isOpen) {
          event.preventDefault();
          this.close(true);
          return;
        }

        if (!this.isOpen) {
          if (event.target === this.btn && (key === 'ArrowDown' || key === 'ArrowUp')) {
            event.preventDefault();
            this.open();
          }
          return;
        }

        var items = this.enabledOptions();
        var index = items.indexOf(document.activeElement);

        if (key === 'ArrowDown' || key === 'ArrowUp') {
          event.preventDefault();
          var step = key === 'ArrowDown' ? 1 : -1;
          var next = index < 0 ? 0 : (index + step + items.length) % items.length;
          if (items[next]) items[next].focus();
          return;
        }

        if (key === 'Home' || key === 'End') {
          event.preventDefault();
          var edge = key === 'Home' ? items[0] : items[items.length - 1];
          if (edge) edge.focus();
          return;
        }

        if ((key === 'Enter' || key === ' ' || key === 'Spacebar') && index > -1) {
          event.preventDefault();
          this.choose(items[index]);
        }
      }

      onOption(event) {
        var option = event.currentTarget;
        if (option.getAttribute('aria-disabled') === 'true') return;
        this.choose(option);
      }

      choose(option) {
        if (!option) return;

        if (this.mode === 'navigate') {
          var href = option.getAttribute('data-jp-href');
          if (href) window.location.href = href;
          return;
        }

        this.options.forEach(function (item) {
          var selected = item === option;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.classList.toggle('is-active', selected);
        });

        if (this.valueNode) {
          this.valueNode.textContent =
            option.getAttribute('data-jp-label') || option.textContent.trim();
        }

        if (this.native) {
          this.native.value = option.getAttribute('data-jp-value') || this.native.value;
          this.native.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.close(true);
      }
    }

    customElements.define('jp-select', JpSelectElement);
  }

  /* ----------------------------------------------------------------- <jp-tip> */
  /** Popover do "?" do brinde: clique/Esc/clique fora, sem dependência externa. */
  function defineTip() {
    if (customElements.get('jp-tip')) return;

    class JpTipElement extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('[data-jp-tip-btn]');
        this.pop = this.querySelector('[data-jp-tip-pop]');
        if (!this.btn || !this.pop) return;

        this._onBtn = this.toggle.bind(this);
        this._onDoc = this.onDoc.bind(this);
        this._onKey = this.onKey.bind(this);

        this.btn.addEventListener('click', this._onBtn);
        document.addEventListener('click', this._onDoc);
        document.addEventListener('keydown', this._onKey);
      }

      disconnectedCallback() {
        if (this.btn && this._onBtn) this.btn.removeEventListener('click', this._onBtn);
        if (this._onDoc) document.removeEventListener('click', this._onDoc);
        if (this._onKey) document.removeEventListener('keydown', this._onKey);
      }

      toggle(event) {
        event.stopPropagation();
        this.render(this.pop.hidden);
      }

      render(show) {
        this.pop.hidden = !show;
        this.btn.setAttribute('aria-expanded', show ? 'true' : 'false');
      }

      onDoc(event) {
        if (this.pop.hidden) return;
        if (this.contains(event.target)) return;
        this.render(false);
      }

      onKey(event) {
        if (event.key === 'Escape' && !this.pop.hidden) this.render(false);
      }
    }

    customElements.define('jp-tip', JpTipElement);
  }

  defineBuyForm();
  defineOfferTimer();
  defineGallery();
  defineStickyCta();
  defineSelect();
  defineTip();
})();
